import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
// Import UI Components
import { Icon } from '@geneui/components';
// Import Types
import type { SubscriptionPlanLocalModel } from './types';
// Import Constants
import { l } from 'constants/common';

interface Props {
    data: SubscriptionPlanLocalModel;
}

const SubscriptionPlanWidget: React.FC<Props> = ({ data }) => {
    const { t } = useTranslation();

    return (
        <div className={classNames('subscription-widget-container', { current: data.isCurrentPlan })}>
            {data.isCurrentPlan && <span className="plan-card__badge">{t(l.Current)}</span>}
            <div className="subscription-widget-header">
                <h2>{data.DisplayName}</h2>
            </div>

            <ul className="modules-list">
                {data.Modules.map((module, index) => (
                    <li key={index} className={module.isReference ? 'ref-module' : ''}>
                        <Icon type="bc-icon-success" />
                        {module.text}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default memo(SubscriptionPlanWidget);
